import { Link, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import ExitIcon from '@/assets/icons/ic-exit.svg';
import LoginIcon from '@/assets/icons/ic-login.svg';

import { selfServiceEventsURL } from '@/constants/self-service-dashboard-routes';
import { IUser } from '@/resources/upgrade/User';
import { AnyProfile } from '@/utils/profileHelpers';

import { EventNavigationItem } from '../EventNavigationItem/EventNavigationItem';
import { ProfileIcon } from '../ProfileIcon/ProfileIcon';

export const MobileUserNavigation: FC<{
  user: IUser;
  currentUserProfile: AnyProfile;
  enableTooltip: boolean;
  redirectUrl: string;
  onLogout: () => void;
}> = ({ user, currentUserProfile, enableTooltip, redirectUrl, onLogout }) => {
  const { t } = useTranslation();

  if (!user) {
    return (
      <NextLink href={`/log-in?redirectUrl=${redirectUrl}`} passHref legacyBehavior>
        <EventNavigationItem mb={12} display={{ base: 'inherit', lg: 'none' }} Icon={<LoginIcon />}>
          <Text as="span" fontSize="md" lineHeight="base" textTransform="capitalize">
            {t('action.logIn')}
          </Text>
        </EventNavigationItem>
      </NextLink>
    );
  }

  return (
    <Fragment>
      {currentUserProfile && (
        <NextLink href="/my-account/profile" passHref legacyBehavior>
          <EventNavigationItem
            mb={2}
            enableTooltip={enableTooltip}
            Icon={<ProfileIcon profile={currentUserProfile} size={24} />}
            display={{ base: 'inherit', lg: 'none' }}
          >
            <Text as="span" fontSize="md" lineHeight="base" textTransform="capitalize">
              {t('action.myProfile')}
            </Text>
          </EventNavigationItem>
        </NextLink>
      )}
      {user.isEventManager && (
        <Link
          href={selfServiceEventsURL}
          display={{ lg: 'none' }}
          pl="4.5rem"
          py="4"
          fontSize="md"
          lineHeight="base"
          textTransform="capitalize"
          textAlign="left"
          minH="3.5rem"
          _hover={{ fontFamily: 'underline' }}
        >
          {t('action.myOrganizedEvents')}
        </Link>
      )}
      <EventNavigationItem mb={2} onClick={onLogout} display={{ base: 'inherit', lg: 'none' }} Icon={<ExitIcon />}>
        <Text as="span" fontSize="md" lineHeight="base" textTransform="capitalize">
          {t('action.logOut')}
        </Text>
      </EventNavigationItem>
    </Fragment>
  );
};
